import React, { useEffect, useState, useRef } from 'react';
import { Container, Complemento } from './styles3';

import WebFont from "webfontloader";
import LogoErpWorks from "~/assets/logos/Logo ErpWorks Proposta Azul.png";
import CheckChecked from "~/assets/logos/check_proposta_checked.png";
import CheckUnChecked from "~/assets/logos/check_proposta_unchecked.png";

function Pagina3({ data, produtos }) {
  let linhas = "";//string.match(/(\r\n|\n|\r)/gm);
  let quantidadeLinhas = linhas ? linhas.length : 0;
  let resto = 0;

  return (
    <>
      <Container>
        <div className="barra-sup"></div>
        <div className="barra-sup2"></div>
        <div className="barra-sup3"></div>
        <div className="barra-sup4"></div>
        <div className="header">
          <div class="text">
            <p class="titulo">Data Emissão</p>
            <p class="titulo-data">{(new Date().toLocaleString('pt-BR', { timeZone: 'UTC' }))}</p>
          </div>
        </div>
        <div className="body">
          <div className="mid">
            <p class="titulo-orcamento">ORÇAMENTO</p>
            <div class="text">
              <p class="titulo-list">Serviços Atribuídos</p>
              <div class="list">
                {produtos?.map((itemProd) => (
                  <div className="prod">
                    {
                      itemProd?.id == data?.idProduto ? (
                        <img className="img-checked" src={CheckChecked} alt="CheckChecked" />
                      ) : (
                        <img className="img-check" src={CheckUnChecked} alt="CheckUnChecked" />
                      )
                    }
                    <p class="titulo">{itemProd?.titulo}</p>
                  </div>
                ))}
              </div>
            </div>
            <div class="tabela">
              <p class="titulo-list">Atividades Atribuídas</p>
              <div class="list">
                {data?.atividades?.map((itemAtv) => (
                  <div className="item">
                    <p class="titulo-item">{itemAtv?.titulo}</p>
                    <div className="valor">
                      <p class="titulo">{itemAtv?.horaTotal}h</p>
                      <p class="titulo">{(data?.valorHora * itemAtv?.horaTotal).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="item-plist">
                <p class="titulo-item"></p>
                <div className="valor">
                  <p class="titulo">{data?.horaTotal}h</p>
                  <p class="titulo">{(data?.valorHora * data?.horaTotal).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="bottom">
            <div className="logo">
              <img className="logo-roda" src={LogoErpWorks} alt="Logo Erpworks" />
              <div className="text-roda">
                <pre>
                  Validade da proposta: {data?.diasVencimento} dias corridos a partir da data de emissão da proposta
                  <br />Formas de pagamento: {data?.tipoPagamento == "DP" ? "Depósito em conta corrente ou Pix" : "Depósito em conta corrente ou Pix"}.
                </pre>
              </div>
            </div>
            <div className="preco">
              <div className="descount">
                <div className="percent">
                  <p>{data?.percentualDesconto > 0 ? "-" + data?.percentualDesconto + "%" : data?.horaTotal + " h(s)"}</p>
                </div>
                <p className="valor-descont">
                  {
                    data?.percentualDesconto > 0 
                    ? ((data?.valorTotal || 0) + (data?.valorDesconto || 0)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    : ((data?.valorHora || 0)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                  }
                </p>
              </div>
              <div className="final-valor">
                <p className="valor-descont">{(data?.valorTotal || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
              </div>
            </div>
          </div>
        </div>
      </Container >
    </>
  );
};

export default Pagina3;